import { useContext } from 'react';
import { AppContext } from '../App';
import { isLabViewer } from '../utils/userAccountRole';

/**
 * True when the signed-in session is a read-only lab Viewer.
 *
 * Components call this to hide write controls. Reading the context defensively
 * keeps the hook usable in components rendered without an AppContext provider
 * (notably existing unit tests), where it resolves to false.
 *
 * @returns {boolean}
 */
export function useIsLabViewer() {
  const context = useContext(AppContext) || {};
  return isLabViewer(context.userDetails, context.isSupplier);
}

export default useIsLabViewer;
